const state = {
  filters: {
    selectedCategories: [],
    selectedFrequencies: [],
    selectedProximity: 40,
    selectedCountry: null,
    searchQuery: null,
    pagination: {
      page: 0,
      size: 12,
    },
  },
  lastItemViewed: null,
};

const mutations = {
  // eslint-disable-next-line no-shadow
  SET_FILTERS(state, filters) {
    state.filters = { ...filters };
  },
  // eslint-disable-next-line no-shadow
  SET_LAST_ITEM_VIEWED(state, item) {
    state.lastItemViewed = item;
  },
};

const actions = {
  updateFilters({ commit }, filters) {
    commit('SET_FILTERS', filters);
  },
  updateLastItemViewed({ commit }, item) {
    commit('SET_LAST_ITEM_VIEWED', item);
  },
};

const getters = {
  // eslint-disable-next-line no-shadow
  getFilters: (state) => state.filters,
  // eslint-disable-next-line no-shadow
  getLastItemViewed: (state) => state.lastItemViewed,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
